import { render, staticRenderFns } from "./barcode_approval.vue?vue&type=template&id=74ae1b0e"
import script from "./barcode_approval.vue?vue&type=script&lang=js"
export * from "./barcode_approval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports